/* TSEF米玩刃物店 theme script — no dependencies. UI strings come from window.tsefT (set in layout/theme.liquid from the locale files). */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var T = window.tsefT || {};
  function tr(key, fallback) { return T[key] || fallback; }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Header: search + mobile menu toggles */
  $all('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-toggle'));
      if (!target) return;
      var open = target.hasAttribute('hidden');
      $all('[data-toggle]').forEach(function (other) {
        var t = document.getElementById(other.getAttribute('data-toggle'));
        if (t && t !== target) { t.setAttribute('hidden', ''); other.setAttribute('aria-expanded', 'false'); }
      });
      if (open) { target.removeAttribute('hidden'); } else { target.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var f = target.querySelector('input, a'); if (f) f.focus(); }
    });
  });

  /* Close dropdown / panels on outside click or Escape */
  function closePanels(except) {
    $all('[data-toggle]').forEach(function (b) {
      var t = document.getElementById(b.getAttribute('data-toggle'));
      if (t && t !== except && !t.hasAttribute('hidden')) { t.setAttribute('hidden', ''); b.setAttribute('aria-expanded', 'false'); }
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toggle]') || e.target.closest('#mega, #header-search, #mobile-nav')) return;
    var mega = document.getElementById('mega');
    if (mega && !mega.hasAttribute('hidden')) closePanels();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* 所有商品: position dropdown under the menu item, open on hover (desktop) */
  function placeMega() {
    var w = document.querySelector('[data-mega-wrap]'), p = document.querySelector('[data-mega-panel]');
    if (!w || !p) return;
    var hdr = p.parentElement.getBoundingClientRect(), r = w.getBoundingClientRect();
    p.style.left = Math.max(8, r.left - hdr.left) + 'px';
  }
  window.addEventListener('resize', placeMega);
  $all('[data-toggle="mega"]').forEach(function (b) { b.addEventListener('click', placeMega); });
  var megaWrap = $('[data-mega-wrap]'), megaPanel = $('[data-mega-panel]');
  if (megaWrap && megaPanel && window.matchMedia('(hover: hover) and (min-width: 901px)').matches) {
    var megaBtn = $('.nav__mega-btn', megaWrap), megaTimer;
    var openMega = function () { clearTimeout(megaTimer); megaPanel.removeAttribute('hidden'); megaBtn.setAttribute('aria-expanded', 'true'); };
    var closeMega = function () { megaTimer = setTimeout(function () { megaPanel.setAttribute('hidden', ''); megaBtn.setAttribute('aria-expanded', 'false'); }, 180); };
    [megaWrap, megaPanel].forEach(function (el) { el.addEventListener('mouseenter', openMega); el.addEventListener('mouseleave', closeMega); });
  }

  /* Cart count + toast */
  function setCount(n) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $all('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', tr('cartLabel', '購物車，__N__ 件商品').replace('__N__', n)); });
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    $('[data-toast-msg]', t).textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4000);
  }

  /* Ajax add to cart (product cards, product page, cart add-ons) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn && btn.querySelector('.kbtn__label');
    var original = label ? label.textContent : '';
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || tr('addFailed', '加入失敗'));
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        if (form.hasAttribute('data-reload')) { window.location.reload(); return; }
        toast(tr('added', '已加入購物車'));
        if (btn) {
          btn.classList.add('is-added');
          if (label) label.textContent = tr('added', '已加入購物車');
          setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2500);
        }
      })
      .catch(function (err) { toast(err.message || tr('addFailedRetry', '加入失敗，請再試')); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var max = input.max ? parseInt(input.max, 10) : 99;
    var v = (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = Math.max(min, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: quantity change / remove via cart/change.js */
  $all('[data-cart-line]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-cart-line');
      document.body.style.cursor = 'progress';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Cart page: gift flag + note autosave (attribute name stays in Chinese so orders read the same in admin) */
  var gift = $('[data-cart-gift]');
  if (gift) {
    gift.addEventListener('change', function () {
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { '送禮（唔放價錢單）': gift.checked ? '是' : '' } })
      });
    });
  }
  var note = $('[data-cart-note]');
  if (note) {
    var nt;
    note.addEventListener('input', function () {
      clearTimeout(nt);
      nt = setTimeout(function () {
        fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }, 500);
    });
  }

  /* Cart page: discount code -> /discount/CODE?redirect=/cart */
  var promo = $('[data-promo-form]');
  if (promo) {
    promo.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (document.getElementById('promo') || {}).value || '';
      code = code.trim();
      var msg = document.getElementById('promo-msg');
      if (!code) { msg.textContent = tr('promoEmpty', '請先輸入優惠碼。'); msg.hidden = false; return; }
      window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
    });
  }

  /* Product gallery thumbs */
  $all('[data-gallery]').forEach(function (gallery) {
    var main = $('.js-gallery-main', gallery);
    if (!main) return;
    $all('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
        $all('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  });

  /* Back-in-stock modal */
  var modal = $('#bis-modal');
  var lastFocus;
  function openModal(trigger) {
    if (!modal) return;
    lastFocus = trigger || document.activeElement;
    if (trigger && trigger.dataset.product) {
      var d = trigger.dataset;
      $('[data-bis-title]', modal).textContent = d.product;
      $('[data-bis-brand]', modal).textContent = d.brand || '';
      $('[data-bis-price]', modal).textContent = d.price || '';
      var img = $('[data-bis-img]', modal);
      if (img) { if (d.image) { img.src = d.image; img.hidden = false; } else { img.hidden = true; } }
      var hidden = $('[data-bis-field]', modal);
      if (hidden) hidden.value = d.product + (d.sku ? '（' + d.sku + '）' : '') + ' ' + window.location.origin + (d.url || '');
    }
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    var f = $('input[type="email"]', modal) || $('.modal__close', modal);
    if (f) f.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bis-open]');
    if (t) { e.preventDefault(); openModal(t); return; }
    if (e.target.closest('[data-bis-close]') || e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModal(); });
  var bisForm = document.getElementById('bis-form');
  if (modal && bisForm) {
    var KEY = 'tsef-bis';
    var pending = null;
    try { pending = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) { pending = null; }
    var posted = modal.getAttribute('data-posted') === 'true' || /contact_posted=true/.test(window.location.search);
    if (pending && posted) {
      $('[data-bis-title]', modal).textContent = pending.title || '';
      $('[data-bis-brand]', modal).textContent = pending.brand || '';
      $('[data-bis-price]', modal).textContent = pending.price || '';
      $('[data-bis-email]', modal).textContent = pending.email || '';
      $('[data-bis-heading]', modal).textContent = tr('bisDone', '到貨通知');
      $('[data-bis-form]', modal).hidden = true;
      $('[data-bis-done]', modal).hidden = false;
      openModal();
      try { sessionStorage.removeItem(KEY); } catch (err) {}
    } else if (pending && modal.hasAttribute('data-has-errors')) {
      $('[data-bis-error]', modal).hidden = false;
      openModal();
    }
    bisForm.addEventListener('submit', function (e) {
      var email = $('input[type="email"]', bisForm);
      var err = $('[data-bis-error]', bisForm);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        e.preventDefault(); email.setAttribute('aria-invalid', 'true'); err.hidden = false; email.focus(); return;
      }
      try {
        sessionStorage.setItem(KEY, JSON.stringify({
          title: $('[data-bis-title]', modal).textContent, brand: $('[data-bis-brand]', modal).textContent,
          price: $('[data-bis-price]', modal).textContent, email: email.value.trim()
        }));
      } catch (err2) {}
    });
  }

  /* Contact form client check */
  $all('form[data-validate]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var bad = false;
      $all('[data-required]', form).forEach(function (el) {
        var v = el.value.trim();
        var ok = el.type === 'email' ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) : !!v;
        el.setAttribute('aria-invalid', ok ? 'false' : 'true');
        var msg = document.getElementById(el.getAttribute('aria-describedby'));
        if (msg) msg.hidden = ok;
        if (!ok && !bad) { bad = true; el.focus(); }
      });
      if (bad) e.preventDefault();
    });
  });

  /* Collection filters: auto-submit + mobile toggle */
  $all('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) form.submit();
    });
  });
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* FAQ: category tabs + search */
  var faq = $('[data-faq]');
  if (faq) {
    var items = $all('[data-faq-item]', faq);
    var tabs = $all('[data-faq-tab]', faq);
    var q = $('[data-faq-search]', faq);
    var empty = $('[data-faq-empty]', faq);
    var cat = 'all';
    function apply() {
      var term = (q && q.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (it) {
        var ok = (cat === 'all' || it.getAttribute('data-cat') === cat) && (!term || it.textContent.toLowerCase().indexOf(term) >= 0);
        it.hidden = !ok;
        if (ok) shown++;
      });
      tabs.forEach(function (t) {
        var c = t.getAttribute('data-faq-tab');
        var n = items.filter(function (it) { return (c === 'all' || it.getAttribute('data-cat') === c) && (!term || it.textContent.toLowerCase().indexOf(term) >= 0); }).length;
        var cnt = t.querySelector('[data-count]'); if (cnt) cnt.textContent = n;
        t.setAttribute('aria-pressed', c === cat ? 'true' : 'false');
      });
      if (term && shown <= 3) items.forEach(function (it) { if (!it.hidden) it.open = true; });
      if (empty) empty.hidden = shown > 0;
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { cat = t.getAttribute('data-faq-tab'); apply(); }); });
    if (q) q.addEventListener('input', apply);
    apply();
  }

  /* Steel table: category filter + column sort */
  var steel = $('[data-steel]');
  if (steel) {
    var tbody = $('tbody', steel);
    var rows = $all('tr', tbody);
    var sortKey = null, sortDir = -1, scat = 'all';
    function render() {
      var list = rows.filter(function (r) { return scat === 'all' || r.getAttribute('data-cat') === scat; });
      rows.forEach(function (r) { r.hidden = list.indexOf(r) < 0; });
      if (sortKey) {
        list.sort(function (a, b) { return (parseInt(a.getAttribute('data-' + sortKey), 10) - parseInt(b.getAttribute('data-' + sortKey), 10)) * (sortDir === 1 ? 1 : -1); });
      } else {
        list.sort(function (a, b) { return a.getAttribute('data-i') - b.getAttribute('data-i'); });
      }
      list.forEach(function (r) { tbody.appendChild(r); });
      $all('[data-sort-key]', steel).forEach(function (b) {
        var on = b.getAttribute('data-sort-key') === sortKey;
        b.classList.toggle('is-active', on);
        b.querySelector('[data-arrow]').textContent = on ? (sortDir === 1 ? '↑' : '↓') : '';
        b.closest('th').setAttribute('aria-sort', on ? (sortDir === 1 ? 'ascending' : 'descending') : 'none');
      });
      $all('[data-steel-tab]', steel).forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-steel-tab') === scat ? 'true' : 'false'); });
    }
    $all('[data-sort-key]', steel).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-sort-key');
        if (sortKey === k) sortDir = -sortDir; else { sortKey = k; sortDir = -1; }
        render();
      });
    });
    $all('[data-steel-tab]', steel).forEach(function (t) { t.addEventListener('click', function () { scat = t.getAttribute('data-steel-tab'); render(); }); });
  }
})();

/* v2.27: mega tabs — one category open at a time, list spans full width */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-mega-tab]'); if (!t) return;
  e.preventDefault(); e.stopPropagation();
  var open = t.getAttribute('aria-expanded') !== 'true';
  document.querySelectorAll('[data-mega-tab]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  document.querySelectorAll('[data-mega-pane]').forEach(function (p) { p.hidden = true; });
  if (open) { t.setAttribute('aria-expanded', 'true'); var p = document.querySelector('[data-mega-pane="' + t.dataset.megaTab + '"]'); if (p) p.hidden = false; }
});
